import axios from "axios"

export function createTemplate(payload) {
  return new Promise((resolve, reject) => {
    axios.post("/serialnumber/api/v1/product-ui-template", payload)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  })
}
